module.exports = __webpack_public_path__ + "static/media/recycling.b102675c.png";